<template>
  <v-toolbar fixed
             height="68"
             class="z-index-fix my-headers"
             color="white"
             :class="firstLogin || isFirstGrowthSystemLogin ? 'fix-parent-z-index':''"
             v-intro-autostart="firstLogin || isFirstGrowthSystemLogin"
             v-intro-autostart.config="{ exitOnOverlayClick: false }"
             v-intro-autostart:on.autostart="onAutostart"
             v-intro-autostart:on.complete="onComplete"
             v-intro-autostart:on.exit="onExit"
             v-intro-autostart:on.beforeexit="onBeforeExit">
    <!-- 使用了vuetify组件的写法之后,含有了子元素,暂时使用  mouseover替代mouseenter mouseout替代mouseleave mouseenter mouseleave-->
    <!-- 不论鼠标指针穿过被选元素或其子元素，都会触发 mouseover 事件。只有在鼠标指针穿过被选元素时，才会触发 mouseenter 事件 -->
    <!-- 悬浮有时候出现离开的时候位icon的状态已排除，由于btn的高度位36px不是50px所以上下存在了空隙对应的当再这个空隙范围触发变成icon的时候，已经离开了icon的范围，自然不能触发leave事件 -->
    <!-- <h3 v-intro="'Step 1, default'"
            v-intro-step="1">Intro step 1</h3> -->
    <!-- <v-toolbar-title class="icon-index text-md-center"
                     v-intro-step="1"
                     v-intro="'Click logo to return to the home page'"
                     v-intro-position="'bottom-middle-aligned'"
                     v-intro-tooltip-class="'red-bg'"
                     v-intro-highlight-class="'blue-grey darken-4 fix-hint'"
                     v-intro-disable-interaction="false"> -->
      <!-- <v-img 
             :src="headers.logoImg"
             transition="slide-x-transition">
      </v-img> -->
      <!-- <v-btn 
             class="ma-0 btn-height"
             block
             flat
             :ripple="false"
             to="/"> -->
        <router-link to="/" title="home">
          <v-img width="142" :src="headers.logoImg" class="home-icon"></v-img>
          <v-img width="142" :src="headers.logoDarkImg" class="home-icons"></v-img>

        </router-link>
      <!-- </v-btn> -->
    <!-- </v-toolbar-title> -->
    <!-- <v-toolbar-items class="subheading fix-more blue-grey darken-4 star-fix">
      <v-btn flat
             color="blue-grey darken-4"
             :class="(menu.routeName === paths) ? 'teal accent-4 text-none  subheading  border-none':'text-none  subheading border-none'"
             v-for="menu in menus.filter(m => m.type===0 &&  m.isShow)"
             :key="menu.name"
             :to="{ name: menu.routeName}">
        <span :class="(menu.routeName === paths) ? 'white--text':'grey--text text--lighten-2'">{{ menu.name }}</span>
      </v-btn>
    </v-toolbar-items> -->
    <!-- <v-menu class="text-none grey--text text--lighten-2 subheading height-fix-menu"
            offset-y
            right
            attach=".fix-more"
            v-show="menus.some(m => !m.isShow)"
            open-on-hover>
      <v-toolbar-title slot="activator"
                       class="subheading ml-3">
        <span>More</span>
        <v-icon dark>arrow_drop_down</v-icon>
      </v-toolbar-title>
      <v-list dense
              class="blue-grey darken-4 py-0 border-none">
        <v-list-tile v-for="menu in menus.filter(m => m.type===0 && !m.isShow)"
                     :key="menu.name"
                     :to="{ name: menu.routeName}"
                     class=""
                     :class="(menu.routeName === paths) ? 'teal accent-4':''">
          <v-list-tile-title :class="(menu.routeName === paths) ? 'white--text':'grey--text text--lighten-2 '"
                             class="subheading">
            {{ menu.name }}
          </v-list-tile-title>
        </v-list-tile>
      </v-list>
    </v-menu> -->
    <!-- <v-spacer></v-spacer> -->
    <!-- <v-menu class="text-none grey--text text--lighten-2 subheading"
            left
            attach=".star-fix"
            offset-y
            :close-on-content-click="false"
            open-on-hover
            max-width="280"
            v-intro="'Use function set menu to edit, display and close menu bar'"
            v-intro-position="'bottom-middle-aligned'"
            v-intro-step="2"
            v-intro-highlight-class="'blue-grey darken-4'"
            v-intro-disable-interaction="false">
      <v-toolbar-title slot="activator"
                       class="subheading px-4">
        <v-icon medium
                color="grey lighten-2">widgets</v-icon>
      </v-toolbar-title>
      <v-container fluid
                   class="blue-grey darken-4 pa-1">
        <v-layout row
                  wrap
                  justify-space-between>
          <v-flex v-for="menu in menus.filter(m => m.enableFolder)"
                  :key="menu.name"
                  xs6>
            <v-card flat
                    tile
                    class="blue-grey darken-4 mx-1">
              <v-btn flat
                     small
                     block
                     class=" text-none grey--text text--lighten-2 blue-grey darken-1 py-1 my-1"
                     @click="$store.dispatch('toggleMenuDisplay', menu.name)">
                <span>{{menu.name}}</span>
                <v-spacer></v-spacer>
                <v-icon small
                        :color="`${menu.isShow ? 'blue darken-1': 'grey'} lighten-2`"
                        class="pl-2">star</v-icon>
              </v-btn>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-menu> -->
    <!-- <div style="color: red;">
      <span @click="changeTheme('theme')">默认</span>&nbsp;&nbsp;&nbsp;
      <span @click="changeTheme('theme1')">dark</span>
    </div> -->
    <v-toolbar-items class="white--text py-2 menu-fix-tag" 
              v-intro="'Shortcut function area'"
              v-intro-position="'bottom-middle-aligned'"
              v-intro-step="firstLogin? '3': ''"
              v-intro-highlight-class="'blue-grey darken-4 fix-hint'"
              v-intro-disable-interaction="false"
>     
      <v-btn v-if="isClient" icon flat color="#b3d4fc" @click="toTemporaryClassroom" class="mx-3 header-class">
            <div class="header-class-icon" title="Temporary Classroom"></div>
      </v-btn>
      <!-- <v-btn icon flat color="#b3d4fc" to="/accentTest" class="mx-3 header-accent">
            <div class="header-accent-icon" title="Accent Test"></div>
      </v-btn> -->
      
      <v-btn icon flat color="#b3d4fc"
             @click="toAiChat"
             class="mx-3">
        <img :src="aiIcon" title="Chat Box"/>
      </v-btn>
        <v-btn icon flat color="#b3d4fc"
             @click="redreictToTask"
             class="mx-3">
        <img :src="taskIcon" title="Teacher Task"/>
      </v-btn>
      <v-btn icon flat color="#b3d4fc"
             @click="redreictToSpeed"
             class="mx-3">
        <img :src="networkIcon" title="Network Test"/>
      </v-btn>
      <v-btn icon
              flat color="#b3d4fc"
             class="mr-4 header-notice"
             to="../message"
            >
        <template v-if="$store.state.message.noReadMsg.total||true">
          <v-badge color="red"  :class="$store.state.message.homeMsg.total.toString().length>2?'headBadge':'botBadge'">
            <!-- <span slot="badge"
                  v-if="$store.state.message.noReadMsg.total>0">{{$store.state.message.noReadMsg.total>99?$store.state.message.noReadMsg.total+'+' :$store.state.message.noReadMsg.total  }}</span> -->
        <!--新增首页消息显示-->
          <span slot="badge"
                  v-if="$store.state.message.homeMsg.total>0">{{$store.state.message.homeMsg.total>99?99+'+' :$store.state.message.homeMsg.total  }}</span>
            <div class="header-notice-icon" title="Message"></div>
          </v-badge>
        </template>
        <template v-else>
          <div class="header-notice-icon" title="Message"></div>
        </template>
      </v-btn>
      <!-- <v-divider vertical
                 class="grey lighten-2"></v-divider> -->
      <!-- v-menu组件使用 attach属性来实现fixed布局,不跟随页面移动而移动位置 -->
      <!-- 坑逼 attach属性 Use either a CSS selector string or an object reference to the element.为选择器形式,css写法,需要加上.xxx而不是单独的xxx -->
      <v-menu open-on-hover
              offset-y
              right
              attach=".menu-fix-tag"
              class="position-fix right-user-info"
             >
        <v-btn flat
                color="#b3d4fc"
                slot="activator"
                class="pa-0 text-none subheading"
               >
          <img :src="user.avatar" width="36" height="36" style="border-radius: 50%;"/>
          <span class="pl-3 blue-title">{{userName}}[{{user.tuid}}]</span>
          <v-icon left class="pl-1 header-panel-icon mr-0">expand_more</v-icon>
        </v-btn>
        <panels></panels>
      </v-menu>
    </v-toolbar-items>
  </v-toolbar>
</template>

<script>
import logo from '../../assets/img/common/Logo_2.png'
import logoDark from '../../assets/img/common/Logo_dark.png'
import network from '../../assets/img/common/headerbar/topbar-icon2.png'
import task from '../../assets/img/common/headerbar/panel-icon8.png'
import aiIcon from '../../assets/img/common/headerbar/AI_2.png'
import { getTemporaryClassroomWebLink } from '@/api/teachinfo'
import { tuEyeProtectionMode, selectEyeProtectionMode,GetTotalUnreadMessageCount } from '@/api/user'

import panels from './personPanel'
import {
  mapGetters
} from 'vuex'
import { getCookie } from '@/utils/tools'
import store from '@/store'
import { removeWatermark, setWaterMark } from '@/utils/watermark'
import { formatDate } from '@/utils/date'

export default {
  name: 'headers',
  components: {
    panels
  },
  computed: {
    ...mapGetters([
      'user',
      'menus',
      'userName'
    ]),
    paths: function () {
      return this.$route.fullPath.split('/')[1]
    },
    firstLogin: function () {
      return this.$store.state.user.isFirstLogin
    },
    isFirstGrowthSystemLogin: function () {
      return this.$store.state.user.isFirstGrowthSystemLogin
    },
    isClient:function(){
      return getCookie('client')==='tutorclient'
    }
  },
  data: () => ({
    headers: {
      logoImg: logo,
      logoHover: false,
      path: '',
      change: 0,
      revert: 0,
      logoDarkImg: logoDark
    },
    networkIcon: network,
    taskIcon:task,
    cNum:0,
    cStartTime: '',
    cLastTime: '',
    currentTheme: 0,
    isChristmasDialogShow: false,
    aiIcon: aiIcon
  }),
  created () {

  },
  mounted(){
    this.tuEyeProtectionMode()
    this.getMsgTotal()
  },
  methods: {
    redreictToSpeed () {
      //window.open('http://www.acadsoc.ph/speed/index.aspx')
      window.open('/speed/speed.html')
    },
    redreictToTask () {
      this.$router.push('/teacherTask')
    },
    toAiChat(){
      this.$store.commit('setAiDialog', true)
    },
    enter () {
      console.log('enter')
      this.headers.logoHover = !this.headers.logoHover
    },
    leave () {
      console.log('leave')
      this.headers.logoHover = !this.headers.logoHover
    },
    enters () {
      this.headers.change++
      console.log('toBtn', this.headers.change, this.headers.logoHover)
      if (this.headers.logoHover === false) {
        this.headers.logoHover = true
      }
    },
    leaves () {
      this.headers.revert++
      console.log('tobImg', this.headers.revert, this.headers.logoHover)
      if (this.headers.logoHover === true) {
        this.headers.logoHover = false
      }
    },
    startTour () {
      this.$intro().start()
    },
    toggleAutostart () {
      this.autostart = !this.autostart
    },
    onComplete (el, introjs) { },
    onExit (el, introjs) {
      this.$store.commit('SET_ISFIRSTLOGIN', false)
      document.getElementsByTagName('body')[0].classList.remove('no-scroll')
      this.$store.commit('SET_GROWTH_SYSTEM_IS_FIRST_LOGIN', false)
    },
    onBeforeExit (el, introjs) { },
    onAutostart (el, introjs) { document.getElementsByTagName('body')[0].classList.add('no-scroll') },
    toTemporaryClassroom(){
      getTemporaryClassroomWebLink().then(res=>{
        if(res.data.Body && res.data.Body.Success){
          window.location.href = res.data.Body.WebLink+`&returnUrl=${encodeURIComponent(window.location.href)}`
        }
      })
    },
    changeTheme (theme) {
      window.document.documentElement.setAttribute('data-theme', theme)
    },
    touchstart(e) {
      if(this.cNum === 0) {
        this.cStartTime = new Date()
        this.cLastTime = this.cStartTime
      } else if (this.cNum>=1) {
        let nextTime = new Date()
        if((nextTime - this.cLastTime)>=3000 || (nextTime - this.cStartTime)>=5000){
          console.log('restart')
          this.cStartTime = nextTime
          this.cLastTime = nextTime
          this.cNum = 0
        }else{
          this.cLastTime = nextTime
        }
        if(this.cNum === 9){
          console.log('suc')
          switch (this.currentTheme) {
             case 0:
              window.document.documentElement.setAttribute('data-theme', 'theme1')
              this.currentTheme = 1
              this.selectEyeProtectionMode()
              break;
              case 1:
                  window.document.documentElement.setAttribute('data-theme', 'theme')
                  this.currentTheme = 0
                  this.selectEyeProtectionMode()
                  break;
              default:
                  break;
          }
          this.cNum = 0
        }
      }
      this.cNum++
    },
    tuEyeProtectionMode(){
      var curTime = formatDate(new Date(),'yyyyMMddhhmm')
      tuEyeProtectionMode().then(res=>{
          this.currentTheme = res
          if(this.currentTheme === 0){
            window.document.documentElement.setAttribute('data-theme', 'theme')
            store.dispatch('setTuEyeProtectionMode', 0)
            setWaterMark(`${this.$store.state.user.tuid}:${curTime}`,'','#ccc');
          }
          if(this.currentTheme === 1){
            window.document.documentElement.setAttribute('data-theme', 'theme1')
            store.dispatch('setTuEyeProtectionMode', 1)
            setWaterMark(`${this.$store.state.user.tuid}:${curTime}`,'','#000');
          }

        })
    },
    selectEyeProtectionMode(){
      selectEyeProtectionMode(this.currentTheme).then(res=>{
          store.dispatch('setTuEyeProtectionMode', this.currentTheme)
      })
    },
    getMsgTotal(){
      GetTotalUnreadMessageCount().then(res=>{
         store.dispatch('addHomeMsg', res.Total)
         store.dispatch('addHomeNoticeMsg', res.Notice)
         store.dispatch('addHomeWarnMsg', res.Warning)
         store.dispatch('addHomeRemindMsg', res.Remind)
      })
    }

  }
}
</script>

<style lang="scss" scoped>
  @import "./headers";
</style>
<style lang="scss">
.headBadge{
  .v-badge__badge{
    width: 28px;
    font-size: 12px;
    height: 18px;
    border-radius: 8px;
  }
}
.botBadge{
   .v-badge__badge{
     font-size: 14px;
   }
}
  .no-scroll {
    position: fixed;
    left: 0;
    right: 0;
  }
  .introjs-helperNumberLayer {
    top: -4px !important;
  }
  .fix-hint + .introjs-tooltipReferenceLayer .introjs-helperNumberLayer {
    top: 6px !important;
  }
  
  .my-headers{
    box-shadow: 0px 2px 10px rgba(125, 162, 255, 0.19);
    .v-toolbar__content{
          justify-content: space-between;
          padding-right: 32px;
    }
    .right-user-info{
      .header-panel-icon{
        // color: $blue-text-lighter;
        font-size: $font-mediumer;
      }
      .v-menu__activator--active{
        .header-panel-icon{
          color:#3E67FB;
        }
      }
    }
  }
  .header-notice{
    width: 36px !important;
    height: 36px;
    &.v-btn--active{
      color:#fff;
      .header-notice-icon{
        background: url(../../assets/img/common/headerbar/topbar-icon3-cur.png) no-repeat center;
      }
    }
    .header-notice-icon{
      background: url(../../assets/img/common/headerbar/topbar-icon3.png) no-repeat center;
      width: 20px;
      height: 20px;
    }
  }
  .header-accent{
    &.v-btn--active{
      color:#fff;
      .header-accent-icon{
        background: url(../../assets/img/common/headerbar/topbar-icon1-cur.png) no-repeat center;
      }
    }
    .header-accent-icon{
      background: url(../../assets/img/common/headerbar/topbar-icon1.png) no-repeat center;
      width: 20px;
      height: 20px;
    }
  }
  .header-class{
    &.v-btn--active{
      color:#fff;
      .header-class-icon{
        background: url(../../assets/img/common/headerbar/topbar-icon4-cur.png) no-repeat center;
      }
    }
    .header-class-icon{
      background: url(../../assets/img/common/headerbar/topbar-icon4.png) no-repeat center;
      width: 20px;
      height: 20px;
    }
  }
  .menu-fix-tag .v-menu__content{
    min-width: 280px!important;
    width: 280px;
    left: auto!important;
    right: 32px;
    @include bg_color($background-color-theme);
  }
  .my-headers{
    @include bg_color($background-color-theme);
  }
  .home-icons,.home-icon{
    display: none;
  }
  [data-theme="theme"] .home-icons, [data-theme="theme1"] .home-icon{
    display: none;
  }

  [data-theme="theme"] .home-icon, [data-theme="theme1"] .home-icons{
    display: block;
  }
  [data-layout="small"] .my-headers .v-toolbar__content{
    height: 50px!important;
    .home-icon, .home-icons {
      width: 126px!important;
    }
    .header-notice .header-notice-icon, .header-accent .header-accent-icon{
        width: 17px!important;
        height: 17px!important;
        background-size: 100%;
    }
    .right-user-info {
      img {
        width: 30px!important;
        height: 30px!important;
      }
      .blue-title{
        font-size: 14px;
      }
    }
  }
  
</style>
